<template>
    <!-- 修改：添加 before-close 事件 -->
    <el-dialog v-model="dialogVisible" :title="!!prizeId ? '编辑奖品' : '新增奖品'" width="600px" :close-on-click-modal="false">
        <!-- {{ form }} -->
        <el-form :model="form" label-width="140px" :rules="rules" ref="formRef" :disabled="loading" :loading="loading">
            <el-form-item label="奖品类型" prop="type">
                <el-select v-model="form.type" placeholder="请选择" class="!w-[200px]" @change="typeChange"
                    :disabled="disableFlg || !!prizeId">
                    <el-option label="实物" :value="1" />
                    <el-option label="优惠券" :value="5" />
                </el-select>
            </el-form-item>

            <el-form-item :label="form.type == 1 ? '奖品名称' : '优惠券名称'" prop="name">
                <el-input v-model="form.name" placeholder="请输入" maxlength="50" show-word-limit :disabled="disableFlg" />
            </el-form-item>

            <el-form-item label="奖品图片" prop="image" v-if="form.type == 1">
                <el-space direction="vertical" alignment="start" v-if="!disableFlg">
                    <NbImageUpload v-model="form.image" :limit="1" size="small" aspect-ratio="1:1" :fileSize="0.5" />
                    <el-text>图片宽高比为1:1, 图片大小不能超过 500kb</el-text>
                </el-space>
                <el-image style="width: 100px; height: 100px" :src="form.image" v-else></el-image>
            </el-form-item>
            <!-- 使用类型相关为groupon_id -->
            <el-form-item label="使用类型" prop="use_type" v-if="form.type == 5">
                <el-radio-group v-model="form.use_type" @change="handleUseTypeChange" :disabled="disableFlg">
                    <el-radio :value="1">通用商品</el-radio>
                    <el-radio :value="2">指定商品</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="选择团购" prop="groupon_id" v-if="form.use_type == 2 && form.type == 5">
                <NbSelectWithRemote ref="selectRef" v-model="form.groupon_id" :searchFunction="service.getGrouponList"
                    :resultHandler="resultHandler1" value-key="id" label-key="title" class="!w-[400px]" load-on-mount
                    :disabled="disableFlg" />
            </el-form-item>
            <el-form-item label="优惠券类型" prop="voucher_type" v-if="form.type == 5">
                <el-radio-group v-model="form.voucher_type" :disabled="disableFlg">
                    <el-radio :value="0">满减券</el-radio>
                    <el-radio :value="1">直减券</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-space v-if="form.type == 5">
                <el-form-item label="优惠券单价" prop="voucher_limit" v-if="form.voucher_type == 0">
                    <el-space>
                        <el-text>满</el-text>
                        <el-input-number v-model="form.voucher_limit" :min="0.02" :max="9999999" :step="0.01"
                            :precision="2" controls-position="right" :disabled="disableFlg" />
                    </el-space>

                </el-form-item>
                <el-form-item :label="form.voucher_type == 1 ? '优惠券单价' : ''"
                    :label-width="form.voucher_type == 1 ? '140px' : '0px'" prop="voucher_price">
                    <el-space>
                        <el-text>减</el-text>
                        <el-input-number v-model="form.voucher_price" :min="0.01" :max="9999999" :step="0.01"
                            :precision="2" controls-position="right" :disabled="disableFlg" />
                    </el-space>
                </el-form-item>
            </el-space>

            <el-form-item label="相对时间" v-if="form.type == 5">
                <el-input-number v-model="form.expired_day" :min="1" :max="9999" :step="1" :precision="0"
                    :controls="false" :disabled="disableFlg" />
                <el-text style="margin-left: 5px">天</el-text>
            </el-form-item>
            <el-form-item label="奖品数量" prop="num">
                <el-input-number v-model="form.num" :min="1" :step="1" :precision="0" :controls="false"
                    :disabled="true" />
            </el-form-item>
            <el-form-item label="抢拍时间" prop="grabTimeRange">
                <el-space align="center">
                    <el-date-picker v-model="form.grabTimeRange" type="datetimerange" range-separator="至"
                        start-placeholder="开始时间" end-placeholder="结束时间" :disabled="!canEditGrabTime || disableFlg"
                        style="width: 370px;" :disabled-date="endDateDisabled" @change="handleDateChange" />
                    <el-button text @click="showConfirmDialog" :disabled="disableFlg" v-if="canEditGrabTimeButton">
                        修改
                    </el-button>
                </el-space>
            </el-form-item>

            <el-form-item label="参考价值" prop="real_price">
                <el-input-number v-model="form.real_price" :min="0.01" :step="0.01" :precision="2" :controls="false"
                    :disabled="disableFlg" />
            </el-form-item>

            <el-form-item label="起拍积分" prop="default_points">
                <el-input-number v-model="form.default_points" :min="0.01" :step="0.01" :precision="2" :controls="false"
                    :disabled="disableFlg" />
            </el-form-item>

            <el-form-item label="最低加价" prop="minimum_point">
                <el-input-number v-model="form.minimum_point" :min="0.01" :step="0.01" :precision="2" :controls="false"
                    :disabled="disableFlg" />
            </el-form-item>

            <el-form-item label="是否有惊喜" prop="is_surprise">
                <el-radio-group v-model="form.is_surprise" :disabled="disableFlg">
                    <el-radio :value="1">否</el-radio>
                    <el-radio :value="2">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- 新增：根据 hasSurprise 动态显示的表单项 -->
            <el-form-item label="奖品类型" prop="surprise_json_type" v-if="form.is_surprise === 2">
                <el-select v-model="form.surprise_json_type" placeholder="请选择" class="!w-[200px]"
                    :disabled="disableFlg">
                    <el-option label="实物" :value="1" />
                    <el-option label="优惠券" :value="5" />
                </el-select>
            </el-form-item>
            <el-form-item :label="form.surprise_json_type == 1 ? '奖品名称' : '优惠券名称'" prop="surprise_json_name"
                v-if="form.is_surprise === 2">
                <el-input v-model="form.surprise_json_name" placeholder="请输入" maxlength="50" show-word-limit
                    :disabled="disableFlg" />
            </el-form-item>

            <el-form-item label="奖品图片" prop="surprise_json_image"
                v-if="form.surprise_json_type == 1 && form.is_surprise === 2">
                <el-space direction="vertical" alignment="start" v-if="!disableFlg">
                    <NbImageUpload v-model="form.surprise_json_image" :limit="1" size="small" aspect-ratio="1:1"
                        :fileSize="0.5" />
                    <el-text>图片宽高比为1:1, 图片大小不能超过 500kb</el-text>
                </el-space>
                <el-image style="width: 100px; height: 100px" :src="form.surprise_json_image" v-else></el-image>
            </el-form-item>
            <!-- 使用类型相关为groupon_id -->
            <el-form-item label="使用类型" prop="surprise_json_use_type"
                v-if="form.surprise_json_type == 5 && form.is_surprise === 2">
                <el-radio-group v-model="form.surprise_json_use_type" @change="handleSurpriseUseTypeChange"
                    :disabled="disableFlg">
                    <el-radio :value="1">通用商品</el-radio>
                    <el-radio :value="2">指定商品</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="选择团购" prop="surprise_json_groupon_id"
                v-if="form.surprise_json_use_type == 2 && form.surprise_json_type == 5 && form.is_surprise === 2">
                <NbSelectWithRemote ref="selectRef" v-model="form.surprise_json_groupon_id"
                    :searchFunction="service.getGrouponList" :resultHandler="resultHandler" value-key="id"
                    label-key="title" class="!w-[400px]" load-on-mount :disabled="disableFlg" />
            </el-form-item>
            <el-form-item label="优惠券类型" prop="surprise_json_voucher_type"
                v-if="form.surprise_json_type == 5 && form.is_surprise === 2">
                <el-radio-group v-model="form.surprise_json_voucher_type" :disabled="disableFlg">
                    <el-radio :value="0">满减券</el-radio>
                    <el-radio :value="1">直减券</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-space v-if="form.surprise_json_type == 5 && form.is_surprise === 2">
                <el-form-item label="优惠券单价" prop="surprise_json_voucher_limit"
                    v-if="form.surprise_json_voucher_type == 0">
                    <el-space>
                        <el-text>满</el-text>
                        <el-input-number v-model="form.surprise_json_voucher_limit" :min="0.02" :max="9999999"
                            :step="0.01" :precision="2" controls-position="right" :disabled="disableFlg" />
                    </el-space>

                </el-form-item>
                <el-form-item :label="form.surprise_json_voucher_type == 1 ? '优惠券单价' : ''"
                    :label-width="form.surprise_json_voucher_type == 1 ? '140px' : '0px'"
                    prop="surprise_json_voucher_price">
                    <el-space>
                        <el-text>减</el-text>
                        <el-input-number v-model="form.surprise_json_voucher_price" :min="0.01" :max="9999999"
                            :step="0.01" :precision="2" controls-position="right" :disabled="disableFlg" />
                    </el-space>
                </el-form-item>
            </el-space>

            <el-form-item label="相对时间" v-if="form.surprise_json_type == 5 && form.is_surprise === 2">
                <el-input-number v-model="form.surprise_json_expired_day" :min="1" :max="9999" :step="1" :precision="0"
                    :controls="false" :disabled="disableFlg" />
                <el-text style="margin-left: 5px">天</el-text>
            </el-form-item>
            <el-form-item label="奖品数量" prop="surprise_json_num" v-if="form.is_surprise === 2">
                <el-input-number v-model="form.surprise_json_num" :min="1" :step="1" :precision="0" :controls="false"
                    :disabled="disableFlg" />
            </el-form-item>
            <el-form-item label="掉落概率" prop="probability" v-if="form.is_surprise === 2">
                <el-input-number v-model="form.probability" :min="0.01" :max="100" :precision="2" :controls="false"
                    :disabled="disableFlg" />
                <el-text style="margin-left: 5px;">%</el-text>
            </el-form-item>
        </el-form>

        <template #footer>
            <el-button @click="dialogVisible = false" :disabled="loading">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="isSubmitting" :disabled="disableFlg">提交</el-button>
        </template>
        <el-dialog v-model="confirmDialogVisible" width="300px" :close-on-click-modal="false"
            :close-on-press-escape="false">
            <div style="text-align: center; margin-top: 20px;">
                每个商家最多只能调整 3 个商品的抢拍时间
                是否确认修改？
            </div>
            <template #footer>
                <el-button @click="confirmDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmEditGrabTime">确认</el-button>
            </template>
        </el-dialog>
    </el-dialog>
</template>

<script setup>
import { ref, nextTick, watch } from 'vue' // 导入 watch
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import NbImageUpload from '@/components/form/NbSquareImageUpload.vue'
import service from '../service'
import NbSelectWithRemote from '@/components/form/NbSelectWithRemote.vue'
import moment from 'moment'

// 定义 props
const props = defineProps({
    // 示例 prop，可根据实际需求修改
    startTime: {
        type: String,
        default: ''
    },
    endTime: {
        type: String,
        default: ''
    }
})

const dialogVisible = ref(false)
const formRef = ref(null)
const loading = ref(false)
const prizeId = ref('')
const addNum = ref(0)

// 修改时间段次数
const editTimes = ref(0);

const route = useRoute();

const canEditGrabTimeButton = ref(false)

const form = ref({
    activity_id: '', // 新增：活动ID字段
    resource_id: '', // 新增：活动ID字段
    type: 1, // 奖品类型，默认为1（实物）
    name: '', // 奖品名称/优惠券名称
    image: '', // 奖品图片
    use_type: 1, // 使用类型，默认为1（通用商品）此字段仅用于判断是否显示选择团购的选项
    groupon_id: '', // 选择的团购ID
    voucher_type: 1, // 优惠券类型，默认为1（直减券）
    expired_day: 1, // 相对时间，默认为1天
    num: 0, // 奖品数量
    voucher_price: 0, // 减多少
    voucher_limit: 0, // 满多少
    real_price: 0, // 参考价值
    default_points: 0, // 起拍积分
    minimum_point: 0, // 最低加价
    is_surprise: 1, // 是否有惊喜，默认为1（否）
    probability: 0, // 掉落概率
    surprise_json: { // 惊喜奖品信息
        type: 1, // 惊喜奖品类型
        num: '', // 惊喜奖品数量
        name: '', // 惊喜奖品名称
        image: '', // 惊喜奖品图片
        use_type: 1, // 惊喜奖品使用类型
        groupon_id: '', // 惊喜奖品选择的团购ID
        voucher_type: 1, // 惊喜奖品优惠券类型
        expired_day: 1, // 惊喜奖品相对时间
        voucher_price: 0, // 惊喜奖品优惠券单价
        voucher_limit: 0 // 惊喜奖品优惠券满减金额
    },
    surprise_json_type: 1, // 惊喜奖品类型
    surprise_json_name: '', // 惊喜奖品名称
    surprise_json_image: '', // 惊喜奖品图片
    surprise_json_use_type: 1, // 惊喜奖品使用类型
    surprise_json_groupon_id: '', // 惊喜奖品选择的团购ID
    surprise_json_voucher_type: 1, // 惊喜奖品优惠券类型
    surprise_json_expired_day: 1, // 惊喜奖品相对时间
    surprise_json_voucher_price: 0, // 惊喜奖品优惠券单价
    surprise_json_voucher_limit: 0, // 惊喜奖品优惠券满减金额
    surprise_json_num: 0, // 惊喜奖品数量
    grabTimeRange: [], // 抢拍时间范围，仅用于显示
    start_time: '', // 抢拍开始时间，仅用于提交
    end_time: '', // 抢拍结束时间，仅用于提交
    is_update: 1, // 是否更新，默认为1（否）
    activity_start_time: '', // 活动开始时间，仅用于时间校验
    activity_end_time: '', // 活动结束时间，仅用于时间校验
})

// 新增：控制抢拍时间是否可编辑的状态
const canEditGrabTime = ref(false)
const confirmDialogVisible = ref(false)

const endDateDisabled = (time) => {
    // console.log('pickerOptions', time, props.startTime, props.endTime)
    const startMoment = moment(props.startTime);
    startMoment.startOf('day');
    const startTime = startMoment.toDate().getTime();
    //const startTime = new Date(moment(props.startTime).format('YYYY-MM-DD HH:mm:ss')).getTime();
    const endTime = new Date(moment(props.endTime).format('YYYY-MM-DD HH:mm:ss')).getTime();
    return time.getTime() < startTime || time.getTime() > endTime;
}

const handleDateChange = (value) => {
    // 给开始结束时间赋值
    form.value.start_time = value[0] ? moment(value[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    form.value.end_time = value[1] ? moment(value[1]).format('YYYY-MM-DD HH:mm:ss') : '';
}

const typeChange = () => {
    // 清空校验
    formRef.value.clearValidate()
}

const showConfirmDialog = () => {
    if (canEditGrabTime.value) {
        return
    }
    confirmDialogVisible.value = true;
}

const confirmEditGrabTime = () => {
    form.value.is_update = 2;
    editTimes.value = 1;
    canEditGrabTime.value = true;
    confirmDialogVisible.value = false;
}

const rules = {
    type: [{ required: true, message: '请选择奖品类型', trigger: 'change' }],
    name: [{ required: true, message: '请输入奖品名称', trigger: 'blur' }],
    image: [{ required: true, message: '请上传奖品图片', trigger: 'change' }],
    use_type: [{ required: true, message: '请选择使用类型', trigger: 'change' }],
    groupon_id: [{ required: true, message: '请选择团购', trigger: 'change' }],
    voucher_type: [{ required: true, message: '请选择优惠券类型', trigger: 'change' }],
    voucher_price: [{ required: true, message: '请输入优惠券单价', trigger: 'blur' }],
    voucher_limit: [
        { required: true, message: '请输入优惠券满减金额', trigger: 'blur' },
        {
            validator: (rule, value, callback) => {
                if (value <= form.value.voucher_price) {
                    callback(new Error('满减金额必须大于优惠券面值'))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    real_price: [{ required: true, message: '请输入参考价值', trigger: 'blur' }],
    default_points: [{ required: true, message: '请输入起拍积分', trigger: 'blur' }],
    minimum_point: [{ required: true, message: '请输入最低加价', trigger: 'blur' }],
    is_surprise: [{ required: true, message: '请选择是否有惊喜', trigger: 'change' }],
    grabTimeRange: [
        {
            required: true,
            message: '请选择抢拍时间时间段',
            trigger: 'change'
        }
    ],
    // 新增：动态表单项的校验规则
    surprise_json_type: [{ required: true, message: '请选择奖品类型', trigger: 'change' }],
    surprise_json_num: [{ required: true, message: '请输入奖品数量', trigger: 'blur' }],
    surprise_json_name: [{ required: true, message: '请输入奖品名称', trigger: 'blur' }],
    surprise_json_image: [{ required: true, message: '请上传奖品图片', trigger: 'change' }],
    surprise_json_use_type: [{ required: true, message: '请选择使用类型', trigger: 'change' }],
    surprise_json_groupon_id: [{ required: true, message: '请选择团购', trigger: 'change' }],
    surprise_json_voucher_type: [{ required: true, message: '请选择优惠券类型', trigger: 'change' }],
    surprise_json_voucher_price: [{ required: true, message: '请输入优惠券单价', trigger: 'blur' }],
    surprise_json_voucher_limit: [
        { required: true, message: '请输入优惠券满减金额', trigger: 'blur' },
        {
            validator: (rule, value, callback) => {
                if (value <= form.value.surprise_json_voucher_price) {
                    callback(new Error('满减金额必须大于优惠券面值'))
                } else {
                    callback()
                }
            },
            trigger: 'blur'
        }
    ],
    surprise_json_expired_day: [{ required: true, message: '请输入相对时间', trigger: 'blur' }],
    probability: [{ required: true, message: '请输入掉落概率', trigger: 'blur' }],
}

const emits = defineEmits(['refresh'])

const handleUseTypeChange = () => {
    form.value.groupon_id = ''
}

const handleSurpriseUseTypeChange = () => {
    form.value.surprise_json_groupon_id = ''
}
const disableFlg = ref(false);

const openDialog = (activity_id, prize_id = '', disabledFlg) => {

    if (disabledFlg) {
        disableFlg.value = true;
    } else {
        disableFlg.value = false;
    }
    dialogVisible.value = true;
    canEditGrabTime.value = false;
    // 重置表单
    resetForm();
    nextTick(() => {
        formRef.value.resetFields()
        addNum.value = 0
        prizeId.value = ''
        form.value.resource_id = activity_id
        form.value.activity_id = activity_id
        form.value.grabTimeRange = [props.startTime, props.endTime]
        form.value.start_time = props.startTime
        form.value.end_time = props.endTime
        form.value.activity_start_time = props.startTime
        form.value.activity_end_time = props.endTime
        if (prize_id) {
            getDetail(prize_id)
        } else {
            checkCanEditGrabTimeButton();
        }
    })
}

const checkCanEditGrabTimeButton = () => {
    service.shopPrizeTimeCount({activity_id: form.value.resource_id}).then(res => {
        console.log(res, 'res')
        console.log(res.status == 2, 'res.data.status')
        if (res.status == 2) {
            canEditGrabTimeButton.value = true;
        } else {
            canEditGrabTimeButton.value = false;
        }
    })
}

const resetForm = () => {
    form.value = {
        activity_id: '', // 新增：活动ID字段
        resource_id: '', // 新增：活动ID字段
        type: 1, // 奖品类型，默认为1（实物）
        name: '', // 奖品名称/优惠券名称
        image: '', // 奖品图片
        use_type: 1, // 使用类型，默认为1（通用商品）此字段仅用于判断是否显示选择团购的选项
        groupon_id: '', // 选择的团购ID
        voucher_type: 1, // 优惠券类型，默认为1（直减券）
        expired_day: 1, // 相对时间，默认为1天
        num: 0, // 奖品数量
        voucher_price: 0, // 减多少
        voucher_limit: 0, // 满多少
        real_price: 0, // 参考价值
        default_points: 0, // 起拍积分
        minimum_point: 0, // 最低加价
        is_surprise: 1, // 是否有惊喜，默认为1（否）
        probability: 0, // 掉落概率
        surprise_json: { // 惊喜奖品信息
            type: 1, // 惊喜奖品类型
            num: '', // 惊喜奖品数量
            name: '', // 惊喜奖品名称
            image: '', // 惊喜奖品图片
            use_type: 1, // 惊喜奖品使用类型
            groupon_id: '', // 惊喜奖品选择的团购ID
            voucher_type: 1, // 惊喜奖品优惠券类型
            expired_day: 1, // 惊喜奖品相对时间
            voucher_price: 0, // 惊喜奖品优惠券单价
            voucher_limit: 0 // 惊喜奖品优惠券满减金额
        },
        surprise_json_type: 1, // 惊喜奖品类型
        surprise_json_name: '', // 惊喜奖品名称
        surprise_json_image: '', // 惊喜奖品图片
        surprise_json_use_type: 1, // 惊喜奖品使用类型
        surprise_json_groupon_id: '', // 惊喜奖品选择的团购ID
        surprise_json_voucher_type: 1, // 惊喜奖品优惠券类型
        surprise_json_expired_day: 1, // 惊喜奖品相对时间
        surprise_json_voucher_price: 0, // 惊喜奖品优惠券单价
        surprise_json_voucher_limit: 0, // 惊喜奖品优惠券满减金额
        surprise_json_num: 0, // 惊喜奖品数量
        grabTimeRange: [], // 抢拍时间范围，仅用于显示
        start_time: '', // 抢拍开始时间，仅用于提交
        end_time: '', // 抢拍结束时间，仅用于提交
        is_update: 1, // 是否更新，默认为1（否）
    }
}

const getDetail = async (prize_id) => {
    loading.value = true
    const res = await service.getPrizesDetail({ prize_id }).finally(() => {
        loading.value = false
    })
    console.log(res, 'res')
    prizeId.value = prize_id
    // 给form赋值
    Object.assign(form.value, res)
    if (res.groupon_id) {
        form.value.use_type = 2
    }
    if (res.is_update == 2) {
        canEditGrabTimeButton.value = true;
    } else {
        checkCanEditGrabTimeButton();
    }
    form.value.groupon_id = res.groupon_id == '' ? '' : Number(res.groupon_id);
    console.log(form.value, 'form.value')
    // 处理grabTimeRange 转日期格式 例子1740758400 转为 日期字符串
    form.value.grabTimeRange = [moment(res.start_time * 1000).format('YYYY-MM-DD HH:mm:ss'), moment(res.end_time * 1000).format('YYYY-MM-DD HH:mm:ss')]
    form.value.start_time = moment(res.start_time * 1000).format('YYYY-MM-DD HH:mm:ss')
    form.value.end_time = moment(res.end_time * 1000).format('YYYY-MM-DD HH:mm:ss')
    // 把应该为数字的字段转为数字
    form.value.num = Number(res.num)
    form.value.voucher_price = Number(res.voucher_price)
    form.value.voucher_limit = Number(res.voucher_limit)
    form.value.real_price = Number(res.real_price)
    form.value.default_points = Number(res.default_points)
    form.value.minimum_point = Number(res.minimum_point)
    form.value.probability = Number(res.probability)
    //form.value.surprise_json_num = Number(res.surprise_json_num)
    // 此部分代码做的极为着急，逻辑判断相当混乱

    if (form.value.voucher_limit) {
        form.value.voucher_type = 0;
    } else {
        form.value.voucher_type = 1;
    }
    // 解析json
    if (res.surprise_json && res.surprise_json !== '' && res.surprise_json !== 'null') {
        // json 转对象
        const surprise_json = JSON.parse(res.surprise_json)
        console.log(surprise_json, 'surprise_json')
        form.value.surprise_json_expired_day = Number(surprise_json.expired_day)
        form.value.surprise_json_voucher_price = Number(surprise_json.voucher_price)
        form.value.surprise_json_voucher_limit = Number(surprise_json.voucher_limit)
        form.value.surprise_json_num = Number(surprise_json.num)
        form.value.surprise_json_type = Number(surprise_json.type)
        if (surprise_json.groupon_id) {
            form.value.surprise_json_use_type = 2;
        } else {
            form.value.surprise_json_use_type = 1;
        }
        if (surprise_json.type == 5) {
            form.value.surprise_json_voucher_type = Number(surprise_json.voucher_type);
        }
        if (surprise_json.voucher_type == 1) {
            form.value.surprise_json_voucher_limit = 0;
        }
        form.value.surprise_json_groupon_id = surprise_json.groupon_id == '' ? '' : Number(surprise_json.groupon_id)
        form.value.surprise_json_name = surprise_json.name
        form.value.surprise_json_image = surprise_json.image
        // 给form.value.surprise_json赋值
        Object.assign(form.value.surprise_json, surprise_json)
    }

    if (res.is_surprise === 1) {
        // 重置惊喜奖品相关字段
        form.value.surprise_json = {
            type: 1,
            num: '',
            name: '',
            image: '',
            use_type: 1,
            groupon_id: '',
            voucher_type: 1,
            expired_day: 1,
            voucher_price: 0,
            voucher_limit: 0
        };
        form.value.surprise_json_type = 1;
        form.value.surprise_json_name = '';
        form.value.surprise_json_image = '';
        form.value.surprise_json_use_type = 1;
        form.value.surprise_json_groupon_id = '';
        form.value.surprise_json_voucher_type = 1;
        form.value.surprise_json_expired_day = 1;
        form.value.surprise_json_voucher_price = 0;
        form.value.surprise_json_voucher_limit = 0;
        form.value.surprise_json_num = 0;
        form.value.probability = 0;
    } else {
        const tmpJson = JSON.parse(res.surprise_json)
        if (tmpJson.type == 5) {
            // 清空惊喜奖品图片
            form.value.surprise_json_image = '';
        } else {
            form.value.surprise_json_use_type = 1;
            form.value.surprise_json_groupon_id = '';
            form.value.surprise_json_voucher_type = 1;
            form.value.surprise_json_expired_day = 1;
            form.value.surprise_json_voucher_price = 0;
            form.value.surprise_json_voucher_limit = 0;
        }
    }
    console.log(form.value, 'form.value')
}


const resultHandler = (res) => {
    return res.list.map(item => {
        return {
            id: item.id,
            title: `【${item.identity}】${item.title}`
        }
    })
}

const resultHandler1 = (res) => {
    return res.list.map(item => {
        return {
            id: item.id,
            title: `【${item.identity}】${item.title}`
        }
    })
}
const isSubmitting = ref(false)
const handleSubmit = async () => {
    if (isSubmitting.value) return
    isSubmitting.value = true
    const valid = await formRef.value.validate()
    if (!valid) {
        isSubmitting.value = false
        return
    }
    loading.value = true
    // 验证开始时间和结束时间是否在活动时间范围内
    const startTime = new Date(moment(form.value.start_time).format('YYYY-MM-DD HH:mm:ss')).getTime();
    const endTime = new Date(moment(form.value.end_time).format('YYYY-MM-DD HH:mm:ss')).getTime();
    const activityStartTime = new Date(moment(form.value.activity_start_time).format('YYYY-MM-DD HH:mm:ss')).getTime();
    const activityEndTime = new Date(moment(form.value.activity_end_time).format('YYYY-MM-DD HH:mm:ss')).getTime();
    if (startTime < activityStartTime || endTime > activityEndTime) {
        ElMessage.error('抢拍时间必须在活动时间范围内')
        loading.value = false
        isSubmitting.value = false
        return
    }
    try {
        // 编辑
        if (prizeId.value) {
            const surprise_jsonTmp = {
                type: form.value.surprise_json_type.toString(),
                num: form.value.surprise_json_num.toString(),
                name: form.value.surprise_json_name,
                image: form.value.surprise_json_image,
                use_type: form.value.surprise_json_use_type.toString(),
                groupon_id: form.value.surprise_json_groupon_id,
                voucher_type: form.value.surprise_json_voucher_type.toString(),
                voucher_limit: form.value.surprise_json_voucher_limit,
                voucher_price: form.value.surprise_json_voucher_price,
                expired_day: form.value.surprise_json_expired_day.toString()
            }
            // console.log(surprise_jsonTmp,'surprise_jsonTmp')

            const params = {
                ...form.value,
                prize_id: prizeId.value,
                surprise_json: surprise_jsonTmp,
                probability: form.value.is_surprise === 2 ? form.value.probability : 0,
            }
            console.log(params, 'params');

            const res = await service.updatePrizes(params)
            if (!res) return
            ElMessage.success('操作成功')
            dialogVisible.value = false
            emits('refresh')
        } else {
            const surprise_jsonTmp = {
                type: form.value.surprise_json_type.toString(),
                num: form.value.surprise_json_num.toString(),
                name: form.value.surprise_json_name,
                image: form.value.surprise_json_image,
                use_type: form.value.surprise_json_use_type.toString(),
                groupon_id: form.value.surprise_json_groupon_id,
                voucher_type: form.value.surprise_json_voucher_type.toString(),
                voucher_limit: form.value.surprise_json_voucher_limit,
                voucher_price: form.value.surprise_json_voucher_price,
                expired_day: form.value.surprise_json_expired_day.toString()
            }
            console.log(surprise_jsonTmp, 'surprise_jsonTmp')
            // 新增
            const params = {
                activity_id: form.value.activity_id,
                name: form.value.name,
                type: form.value.type,
                image: form.value.image,
                num: form.value.num,
                start_time: form.value.start_time,
                end_time: form.value.end_time,
                real_price: form.value.real_price,
                default_points: form.value.default_points,
                minimum_point: form.value.minimum_point,
                is_surprise: form.value.is_surprise,
                is_update: form.value.is_update,
                groupon_id: form.value.groupon_id,
                voucher_type: form.value.voucher_type,
                voucher_limit: form.value.voucher_limit,
                voucher_price: form.value.voucher_price,
                expired_day: form.value.expired_day,
                probability: form.value.is_surprise === 2 ? form.value.probability : 0,
                surprise_json: form.value.is_surprise === 2 ? surprise_jsonTmp : '',
            }
            const addRes = await service.addPrizes(params);
            if (!addRes) return
            ElMessage.success('操作成功')
            dialogVisible.value = false
            emits('refresh')
        }

    } catch (error) {
        console.error(error)
    } finally {
        isSubmitting.value = false
        loading.value = false
    }
}

// const handleAppendNumChange = (num) => {
//     addNum.value = num
// }

defineExpose({
    openDialog
})

// 合并两个 watch 为一个
watch([
    () => form.value.image,
    () => form.value.surprise_json_image
], ([newImage, newSurpriseImage], [oldImage, oldSurpriseImage]) => {
    if (newImage && newImage !== oldImage) {
        formRef.value.clearValidate(['image'])
    }
    if (newSurpriseImage && newSurpriseImage !== oldSurpriseImage) {
        formRef.value.clearValidate(['surprise_json_image'])
    }
})
</script>
